import { STATUS_FLEXIBLE_TEXT } from "../commons/commonConstant";
import { getMessages } from "../commons/commons";

export default {
  name: "ConfirmOvertimeModal",
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    handleCancel: Function,
    getData: Function,
    data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      visibleModalConfirm: this.visibleModal,
      ConfirmForm: this.$form.createForm(this, { name: "Confirm Request" }),
      LayoutConfirm: {
        labelCol: { span: 12 },
        wrapperCol: { span: 12 },
      },
      dataOTPay: [],
      isLoading: false,
      STATUS_FLEXIBLE_TEXT,
    };
  },
  created() {
    const { overtimePayDetail } = this.data;
    if (overtimePayDetail?.details) {
      this.dataOTPay = overtimePayDetail?.details.map((item, index) => {
        return {
          ...item,
          keyHour: `otPayConfirm-${index}`,
          keyReason: `reasonConfirm-${index}`,
          required_reason:
            this.data?.status === STATUS_FLEXIBLE_TEXT[1] ? false : !(item?.duration_actual === item?.duration_confirm),
        };
      });
    }
  },
  methods: {
    handleChangeOTPayConfirm(value, max) {
      if (value > max) {
        this.$message.error("OTpay confirmation can not be higher than total time of shift is " + max, 5);
      }
    },
    handleBlur(event, originValue, key, index, keyReason) {
      if (event.target.value) {
        const numberFixed = Number.parseFloat(event.target.value).toFixed(2);
        this.ConfirmForm.setFieldsValue({ [key]: numberFixed });
        if (Number.parseFloat(originValue).toFixed(2) === numberFixed) {
          this.ConfirmForm.resetFields();
          this.ConfirmForm.setFieldsValue({ [key]: numberFixed, [keyReason]: "" });
          this.dataOTPay.splice(index, 1, { ...this.dataOTPay[index], required_reason: false });
        } else {
          this.dataOTPay[index].required_reason = true;
        }
      } else {
        this.ConfirmForm.setFieldsValue({
          [key]: originValue,
        });
        this.dataOTPay.splice(index, 1, { ...this.dataOTPay[index], required_reason: false });
      }
    },
    handleConfirm() {
      this.ConfirmForm.validateFields(async (err, values) => {
        if (!err) {
          const data = this.dataOTPay.map((item) => {
            return {
              ...item,
              duration_confirm: values[item.keyHour],
              reason: values[item.keyReason],
            };
          });
          const payload = {
            requestId: this.data.id,
            action: "confirm",
            details: data,
          };
          const result = await this.updateStatusFlexible(payload);
          if (result) {
            this.handleCancelConfirm();
            this.getData();
          }
        }
      });
    },
    async updateStatusFlexible(payload) {
      this.isLoading = true;
      return this.$store
        .dispatch("overtime/updateStatusOTFlexibleRequest", payload)
        .then((res) => {
          let check = "success";
          if (parseInt(res.code) === 200 || parseInt(res.code) === 201) {
            check = "success";
            getMessages(res.message).forEach((msg) => {
              this.$message.success(msg, 5);
            });
          } else if (parseInt(res.code) === 207) {
            check = "warn";
            const messages = getMessages(res.message);
            if (messages && messages.length > 0) {
              for (let i = 0; i < messages.length; i++) {
                if (i === 0) {
                  this.$message.success(messages[i], 5);
                } else {
                  this.$message.warn(messages[i], 5);
                }
              }
            }
            check = "success";
          } else {
            check = "fail";
          }
          if (check === "success" || check === "warn") {
            return true;
          } else {
            getMessages(res.message).forEach((err) => {
              this.$message.error(err, 5);
            });
            return false;
          }
        })
        .catch((errors) => {
          getMessages(errors.response?.data?.message).forEach((err) => {
            this.$message.error(err, 5);
          });
          return false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleCancelConfirm() {
      this.handleCancel();
      this.visibleModalConfirm = false;
    },
  },
};
